<template>
    <div id="list-paymentStatusesCodes-component" class="w-full flex flex-col">
        <custom-simple-select
            v-if="enabled"
            v-model="option"
            label="Estado pago *"
            :options="selectOptions"
            @change="onInput"
        />
        <div v-else class="flex flex-col">
            <strong>Estado pago </strong>
            <span
                class="mt-2 ml-2"
                :class="$data.$paymentStatusesMessageClass[option]"
            >
                {{ $data.$paymentStatusesCodes[itemCurrent] }} &nbsp;
                <small>({{ itemCurrent }})</small>
            </span>
        </div>
    </div>
</template>

<script>
import {
    paymentStatusesCodes,
    paymentStatusesMessageClass
} from "@/common/fields/orders-payment-status-codes";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "PaymentStatusSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "pending",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "",
        $paymentStatusesCodes: paymentStatusesCodes,
        $paymentStatusesMessageClass: paymentStatusesMessageClass
    }),
    computed: {
        selectOptions() {
            return Object.entries(this.$data.$paymentStatusesCodes).map(
                ([key, value]) => ({ label: value, value: key })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
